import axios from 'axios';
import ajax from './ajax.config';
let cancelList = {}; // 存放取消的请求方法

// axios 配置
axios.defaults.timeout = ajax.timeOut;
axios.defaults.headers.post['Content-Type'] = ajax.contentType;
axios.defaults.baseURL = ajax.baseURL || '';
// 添加请求拦截器
axios.interceptors.request.use((config) => {
    if (config.method === 'get') {
        config.data = true;
    }
    return config;
});

// 添加响应拦截器
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (res) => {
        let responseConfig = res.config.responseConfig;
        let state = responseConfig.stateName;
        let msg = responseConfig.msgName;
        let response = {};
        if (axios.isCancel(res)) {
            response[state] = 'cancel';
            response[msg] = res.msg || 'request cancel';
        } else {
            response[state] = res.response.status;
            response[msg] = res.response.statusText;
        }
        return Promise.reject(response);
    }
);

const request = function (...opt) {
    if (opt.length > 1 || (opt.length === 1 && typeof opt[0] === 'string')) {
        opt = {
            url: opt[0],
            data: opt[1] || {}
        };
    }
    if (Object.prototype.toString.call(opt[0]) === '[object Object]') {
        opt = opt[0];
    }
    let cancelId = opt.url + JSON.stringify(opt.data);
    if (cancelList[cancelId]) {
        opt.CANCEL = cancelList[cancelId];
    }
    ajax.hooks.eachBefore && ajax.hooks.eachBefore.call(this, opt);
    const promise = new Promise((resolve, reject) => {
        let method = opt.method || ajax.type;
        let headers = {
            'Content-Type': opt['Content-Type'] ? opt['Content-Type'] : ajax.contentType
        };
        let responseConfig = ajax.response;
        if (Object.prototype.toString.call(opt.response === '[object Object]')) {
            responseConfig = _.extend({}, responseConfig, opt.response);
        }
        if (opt.headers) {
            headers = Object.assign(headers, opt.headers);
        }
        const axiosConfig = {
            cancelToken: new axios.CancelToken(function executor(c) {
                cancelList[cancelId] = c;
            }),
            headers: headers,
            responseType: opt.responseType || 'json',
            responseConfig
        };
        axios[method](
            opt.url,
            method === 'get'
                ? {
                      params: opt.data,
                      ...axiosConfig
                  }
                : opt.data,
            axiosConfig
        ).then(
            (res) => {
                resolve(res.data);
            },
            (response) => {
                if (response[responseConfig.stateName] !== 'cancel') {
                    reject(response);
                }
            }
        );
    });
    promise
        .then((response) => {
            ajax.hooks.eachSuccess && ajax.hooks.eachSuccess.call(this, response, opt);
            ajax.hooks.eachComplete && ajax.hooks.eachComplete.call(this, response, opt);
        })
        .then(null, (response) => {
            ajax.hooks.eachFailure && ajax.hooks.eachFailure.call(this, response, opt);
            ajax.hooks.eachComplete && ajax.hooks.eachComplete.call(this, response, opt);
        });
    return promise;
};
export default request;
